import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType,
    CommonRoutes, IconType,
} from 'app/enums/common.enums'
import {
    RegionSecondLevel, SimplifiedQuoteStatus,
} from 'app/enums/label.enums'

import TextIcon from 'app/common/DomainObject/ComponentMapper/TextIcon'
import {
    SimplifiedCQuoteTable,
} from './SimplifiedCQuotes.types'

const config: SkyNetTableConfig<keyof SimplifiedCQuoteTable> = {
    name: 'simplified-cquote',
    tabs: [{
        name: 'All',
        url: CommonRoutes.All,
        fields: [
            {
                name: 'simplifiedQuoteNumber',
                labelKey: 'AccountQuotes.quoteNumber',
                reduced: true,
                mapCellProps: ({
                    simplifiedQuoteNumber,
                    status,
                }) => {
                    const result = {
                        value: simplifiedQuoteNumber,
                    }

                    if (status === SimplifiedQuoteStatus.UNKNOWN) {
                        return {
                            ...result,
                            type: IconType.RedWarning,
                            tooltip: 'Specify whether this quote led to winning the business and provide the reason.',
                        }
                    }

                    return result
                },
                Cell: TextIcon,
            },
            {
                name: 'companyName',
                labelKey: 'AccountQuotes.quotedForCompany',
                filterField: 'companyName',
                filterType: FilterType.Array,
            },
            {
                name: 'originRegion',
                labelKey: 'AccountQuotes.originRegionL2',
                componentName: 'EnumValue',
                allowedValuesEnum: RegionSecondLevel,
                filterField: 'originRegion',
                filterType: FilterType.Array,
            },
            {
                name: 'originCountryCountryName',
                labelKey: 'AccountQuotes.originCountry',
                filterField: 'originCountryCountryName',
                filterType: FilterType.Array,
            },
            {
                name: 'originAirportIataCode',
                labelKey: 'AccountQuotes.originIATA',
                filterField: 'originAirportIataCode',
                filterType: FilterType.Array,
            },
            {
                name: 'destinationRegion',
                labelKey: 'AccountQuotes.destinationRegionL2',
                componentName: 'EnumValue',
                allowedValuesEnum: RegionSecondLevel,
                filterField: 'destinationRegion',
                filterType: FilterType.Array,
            },
            {
                name: 'destinationCountryCountryName',
                labelKey: 'AccountQuotes.destinationCountry',
                filterField: 'destinationCountryCountryName',
                filterType: FilterType.Array,
            },
            {
                name: 'destinationAirportIataCode',
                labelKey: 'AccountQuotes.destinationIATA',
                filterField: 'destinationAirportIataCode',
                filterType: FilterType.Array,
            },
            {
                name: 'status',
                labelKey: 'AccountQuotes.quoteStatus',
                componentName: 'EnumValue',
                allowedValuesEnum: SimplifiedQuoteStatus,
                filterField: 'status',
                filterType: FilterType.Array,
            },
            {
                name: 'createdOn',
                labelKey: 'Accounts.createdOn',
            },
            {
                name: 'createdBy',
                labelKey: 'Accounts.createdBy',
                filterField: 'createdBy',
                filterType: FilterType.Array,
            },
        ],
    }],
}

export default config
